import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Link as MuiLink, Typography } from '@mui/material';
import { Reply as ReplyIcon } from '@mui/icons-material';

import { postPath } from '../../../../Utils/routes';

function ParentLink({ space, slug, title }: any) {
  return (
    <MuiLink
      to={postPath(space.slug, slug)}
      component={Link}
      color="textSecondary"
      underline="hover"
      sx={{ paddingY: 1, paddingX: 3, display: 'inline-flex', gap: 2 }}
    >
      <Box>
        <ReplyIcon sx={{ transform: 'rotateY(180deg)' }} />
      </Box>

      <Box>
        <Typography variant="body1">{title}</Typography>
      </Box>
    </MuiLink>
  );
}

export default ParentLink;
